/**
 * src/app/global-error.js
 *
 * Last-resort error boundary cuando incluso el root layout crashea.
 * Tiene que renderizar su propio <html> y <body> porque RootLayout
 * está fallando. Solo se activa si error.js no puede capturar.
 *
 * Captura el error en Sentry para tener visibility de los crashes más
 * severos del lado cliente — los que rompen incluso el shell del app.
 */

'use client';

import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';

export default function GlobalError({ error, reset }) {
  useEffect(() => {
    // Capturar TODO error que llegue acá — son los más críticos (root crash).
    // Sentry filtra noise (ChunkLoadError, etc) según config en
    // src/instrumentation-client.js → ignoreErrors / beforeSend.
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="es">
      <body style={{
        margin: 0,
        background: '#0a0a0f',
        color: '#fff',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
        padding: '2rem',
      }}>
        <div style={{ maxWidth: 480, textAlign: 'center' }}>
          <h1 style={{ fontSize: '1.5rem', marginBottom: '1rem' }}>Error crítico</h1>
          <p style={{ color: '#a1a1aa', marginBottom: '1.5rem', lineHeight: 1.6 }}>
            La aplicación encontró un problema severo. Recarga la página o
            escríbenos si esto persiste.
          </p>
          <button
            onClick={() => reset()}
            style={{
              background: '#d4af37',
              color: '#000',
              border: 'none',
              padding: '0.85rem 1.5rem',
              borderRadius: 10,
              fontWeight: 700,
              fontSize: '0.9rem',
              cursor: 'pointer',
              marginRight: '0.5rem',
            }}
          >
            Reintentar
          </button>
          <a href="/" style={{
            color: '#a1a1aa',
            textDecoration: 'underline',
            fontSize: '0.85rem',
          }}>
            Volver al inicio
          </a>
        </div>
      </body>
    </html>
  );
}
